import React from "react";
import { FormattedMessage } from "react-intl";
import { actionModalMessages } from "../../../orchestrator.messages";

interface BooleanInputProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

export function BooleanInput({ value, onChange }: BooleanInputProps) {
  return (
    <label className="flex items-center gap-2 cursor-pointer">
      <input
        type="checkbox"
        checked={value}
        onChange={e => onChange(e.target.checked)}
        className="w-4 h-4"
      />
      <FormattedMessage {...actionModalMessages.enabled} />
    </label>
  );
}
